import type { IDirective } from "angular";
import { module } from "angular";
import type { Moment } from "moment-timezone";

import BaseDateDirectiveFunctions from "./BaseDateDirectiveFunctions";

export default class DateMaxDirective implements IDirective {
    public static ValidateFn = (thisDate: Moment, otherDate: Moment, inclusive = false) => {
        return inclusive ? thisDate <= otherDate : thisDate < otherDate;
    };

    public restrict = "A";

    public require = "ngModel";

    public priority: 1;

    public link = BaseDateDirectiveFunctions.link("dateMax", DateMaxDirective.ValidateFn);
}

module("mmGui").directive("irDateMax", () => new DateMaxDirective());
